
import React from 'react';

import colors from 'theme/_colors.scss';
import { IconError, IconInfoNotification, IconSuccess, IconWarning } from 'svgIcons/MotionPortalIcons';
import { NOTIFICATION_TYPES, NOTIFICATION_BAR } from './constants';

export const getNotificationIcon = (notificationType, coloredIcon) => {
	switch (notificationType) {
		case NOTIFICATION_BAR.FREE_FOR_RENEWAL:
		case NOTIFICATION_BAR.FREE:
		case NOTIFICATION_TYPES.ERROR:
			return (
				<IconError width={22} height={22} color={coloredIcon ? colors.pomegranate : null} />
			);
		case NOTIFICATION_TYPES.INFO:
			return (
				<IconInfoNotification width={22} height={22} color={coloredIcon ? colors.primaryInfo : null} />
			);
		case NOTIFICATION_TYPES.SUCCESS:
			return (
				<IconSuccess width={22} height={22} color={coloredIcon ? colors.jungleGreen : null} />
			);
		case NOTIFICATION_TYPES.WARN:
			return (
				<IconWarning width={22} height={22} color={coloredIcon ? colors.orangePeel : null} />
			);
		default:
	}
	return null;
};
